/**
 * A tab opened before a deploy holds an index that names chunks by their
 * old hashes; the first navigation to a not-yet-loaded page then fails with
 * "Failed to fetch dynamically imported module". One reload picks up the
 * current index. The guard stops a reload loop when the chunk is missing
 * for a real reason.
 */

const LAST_RELOAD_KEY = 'wb.chunk-reload.at';
const RELOAD_COOLDOWN_MS = 60_000;

interface ReloadWindow {
  addEventListener: (type: string, fn: (e: Event) => void) => void;
  location: { reload: () => void };
  sessionStorage: Pick<Storage, 'getItem' | 'setItem'>;
}

/** True when a reload is allowed now: none recorded within the cooldown. */
export function shouldReload(now: number, storage: ReloadWindow['sessionStorage']): boolean {
  try {
    const last = Number(storage.getItem(LAST_RELOAD_KEY) ?? 0);
    if (now - last < RELOAD_COOLDOWN_MS) return false;
    storage.setItem(LAST_RELOAD_KEY, String(now));
    return true;
  } catch {
    return true;
  }
}

export function installChunkReload(win: ReloadWindow): void {
  win.addEventListener('vite:preloadError', (event) => {
    if (!shouldReload(Date.now(), win.sessionStorage)) return;
    event.preventDefault();
    win.location.reload();
  });
}
